import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Axios } from "utils";
import { LoadingSpinner } from "shared";
import { useNavigate } from "react-router-dom";

export const ExternalLink = () => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    const refreshToken = params.get("token")

    const {
        data: simulationUrl,
        isLoading,
        isError,
    } = useQuery({
        queryKey: ["external-access-link", id],
        queryFn: () =>
            Axios.get(
                `v2/portal/CourseTasks/${id}/external-access-link?refreshToken=${refreshToken}`
            ).then((res) => res.data),
        enabled: !!id,
    });

    const navigate = useNavigate();

    useEffect(() => {
        if (isError) {
            navigate("/session-expired");
        }
    }, [isError, navigate]);


    if (isLoading) {
        return <LoadingSpinner marinHeight="0px" />
    }

    return (
        <iframe
            src={simulationUrl}
            title="externalLink"
            style={{
                width: "100%",
                height: "100dvh",
                border: "none",
                display: "block"
            }}
        />
    );
};